import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FiltersDesktopPropsInterface } from './DesktopType';
import FiltersOptions from '../FiltersOptions';
import { FiltersSearch } from '../FiltersSearch';

function FiltersDesktop({ data }: Readonly<FiltersDesktopPropsInterface>) {
  return (
    <FuelFlex defaultProps={{ gap: 'km1', alignItems: 'center' }}>
      <FiltersSearch />
      <FiltersOptions data={data} />
    </FuelFlex>
  );
}

export default FiltersDesktop;
